/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as ActivateRouteImport } from './routes/activate'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedCustomersRouteImport } from './routes/_authenticated/customers'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as PublicForgotPasswordRouteImport } from './routes/_public/forgot-password'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as PublicResetPasswordRouteImport } from './routes/_public/reset-password'
import { Route as PublicSignupRouteImport } from './routes/_public/signup'
import { Route as AuthenticatedImportsIndexRouteImport } from './routes/_authenticated/imports/index'
import { Route as AuthenticatedImportsHistoryRouteImport } from './routes/_authenticated/imports/history'
import { Route as AuthenticatedOrdersIndexRouteImport } from './routes/_authenticated/orders/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedSettingsBillingRouteImport } from './routes/_authenticated/settings/billing'
import { Route as AuthenticatedSettingsDefaultsRouteImport } from './routes/_authenticated/settings/defaults'
import { Route as AuthenticatedSettingsHandlingUnitsRouteImport } from './routes/_authenticated/settings/handling-units'
import { Route as AuthenticatedSettingsNationalCarriersRouteImport } from './routes/_authenticated/settings/national-carriers'
import { Route as AuthenticatedSettingsOrderTypesRouteImport } from './routes/_authenticated/settings/order-types'
import { Route as AuthenticatedSettingsOrganizationRouteImport } from './routes/_authenticated/settings/organization'
import { Route as AuthenticatedSettingsServiceKeysRouteImport } from './routes/_authenticated/settings/service-keys'
import { Route as AuthenticatedSettingsShippersRouteImport } from './routes/_authenticated/settings/shippers'
import { Route as AuthenticatedSettingsSpacesRouteImport } from './routes/_authenticated/settings/spaces'
import { Route as AuthenticatedSettingsUsersRouteImport } from './routes/_authenticated/settings/users'
import { Route as AuthenticatedSettingsVehicleTemplatesRouteImport } from './routes/_authenticated/settings/vehicle-templates'
import { Route as AuthenticatedImportsHistoryImportIdRouteImport } from './routes/_authenticated/imports/history_.$importId'
import { Route as AuthenticatedSettingsSpacesIndexRouteImport } from './routes/_authenticated/settings/spaces/index'
import { Route as AuthenticatedSettingsCarriersCarrierIdRouteImport } from './routes/_authenticated/settings_.carriers.$carrierId'
import { Route as AuthenticatedSettingsSitesSiteIdRouteImport } from './routes/_authenticated/settings_.sites.$siteId'
import { Route as AuthenticatedSettingsSpacesSpaceIdRouteImport } from './routes/_authenticated/settings_.spaces.$spaceId'
import { Route as AuthenticatedSettingsCarriersCarrierIdIndexRouteImport } from './routes/_authenticated/settings_.carriers.$carrierId/index'
import { Route as AuthenticatedSettingsCarriersCarrierIdDriversRouteImport } from './routes/_authenticated/settings_.carriers.$carrierId/drivers'
import { Route as AuthenticatedSettingsCarriersCarrierIdSitesRouteImport } from './routes/_authenticated/settings_.carriers.$carrierId/sites'
import { Route as AuthenticatedSettingsCarriersCarrierIdVehiclesRouteImport } from './routes/_authenticated/settings_.carriers.$carrierId/vehicles'
import { Route as AuthenticatedSettingsSitesSiteIdIndexRouteImport } from './routes/_authenticated/settings_.sites.$siteId/index'
import { Route as AuthenticatedSettingsSitesSiteIdCarriersRouteImport } from './routes/_authenticated/settings_.sites.$siteId/carriers'
import { Route as AuthenticatedSettingsSitesSiteIdDefaultsRouteImport } from './routes/_authenticated/settings_.sites.$siteId/defaults'
import { Route as AuthenticatedSettingsSitesSiteIdDriversRouteImport } from './routes/_authenticated/settings_.sites.$siteId/drivers'
import { Route as AuthenticatedSettingsSitesSiteIdUsersRouteImport } from './routes/_authenticated/settings_.sites.$siteId/users'
import { Route as AuthenticatedSettingsSitesSiteIdVehiclesRouteImport } from './routes/_authenticated/settings_.sites.$siteId/vehicles'
import { Route as AuthenticatedSettingsSpacesSpaceIdIndexRouteImport } from './routes/_authenticated/settings_.spaces.$spaceId/index'
import { Route as AuthenticatedSettingsSpacesSpaceIdCarriersRouteImport } from './routes/_authenticated/settings_.spaces.$spaceId/carriers'
import { Route as AuthenticatedSettingsSpacesSpaceIdDriversRouteImport } from './routes/_authenticated/settings_.spaces.$spaceId/drivers'
import { Route as AuthenticatedSettingsSpacesSpaceIdSitesRouteImport } from './routes/_authenticated/settings_.spaces.$spaceId/sites'
import { Route as AuthenticatedSettingsSpacesSpaceIdUsersRouteImport } from './routes/_authenticated/settings_.spaces.$spaceId/users'
import { Route as AuthenticatedSettingsSpacesSpaceIdVehiclesRouteImport } from './routes/_authenticated/settings_.spaces.$spaceId/vehicles'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivateRoute = ActivateRouteImport.update({
  id: '/activate',
  path: '/activate',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCustomersRoute = AuthenticatedCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const PublicForgotPasswordRoute = PublicForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => PublicRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const PublicResetPasswordRoute = PublicResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignupRoute = PublicSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => PublicRoute,
} as any)
const AuthenticatedImportsIndexRoute =
  AuthenticatedImportsIndexRouteImport.update({
    id: '/imports/',
    path: '/imports/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedImportsHistoryRoute =
  AuthenticatedImportsHistoryRouteImport.update({
    id: '/imports/history',
    path: '/imports/history',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrdersIndexRoute =
  AuthenticatedOrdersIndexRouteImport.update({
    id: '/orders/',
    path: '/orders/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsBillingRoute =
  AuthenticatedSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsDefaultsRoute =
  AuthenticatedSettingsDefaultsRouteImport.update({
    id: '/defaults',
    path: '/defaults',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsHandlingUnitsRoute =
  AuthenticatedSettingsHandlingUnitsRouteImport.update({
    id: '/handling-units',
    path: '/handling-units',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsNationalCarriersRoute =
  AuthenticatedSettingsNationalCarriersRouteImport.update({
    id: '/national-carriers',
    path: '/national-carriers',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsOrderTypesRoute =
  AuthenticatedSettingsOrderTypesRouteImport.update({
    id: '/order-types',
    path: '/order-types',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsOrganizationRoute =
  AuthenticatedSettingsOrganizationRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsServiceKeysRoute =
  AuthenticatedSettingsServiceKeysRouteImport.update({
    id: '/service-keys',
    path: '/service-keys',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsShippersRoute =
  AuthenticatedSettingsShippersRouteImport.update({
    id: '/shippers',
    path: '/shippers',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsSpacesRoute =
  AuthenticatedSettingsSpacesRouteImport.update({
    id: '/spaces',
    path: '/spaces',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsUsersRoute =
  AuthenticatedSettingsUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsVehicleTemplatesRoute =
  AuthenticatedSettingsVehicleTemplatesRouteImport.update({
    id: '/vehicle-templates',
    path: '/vehicle-templates',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedImportsHistoryImportIdRoute =
  AuthenticatedImportsHistoryImportIdRouteImport.update({
    id: '/imports/history_/$importId',
    path: '/imports/history/$importId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsSpacesIndexRoute =
  AuthenticatedSettingsSpacesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsSpacesRoute,
  } as any)
const AuthenticatedSettingsCarriersCarrierIdRoute =
  AuthenticatedSettingsCarriersCarrierIdRouteImport.update({
    id: '/settings_/carriers/$carrierId',
    path: '/settings/carriers/$carrierId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsSitesSiteIdRoute =
  AuthenticatedSettingsSitesSiteIdRouteImport.update({
    id: '/settings_/sites/$siteId',
    path: '/settings/sites/$siteId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsSpacesSpaceIdRoute =
  AuthenticatedSettingsSpacesSpaceIdRouteImport.update({
    id: '/settings_/spaces/$spaceId',
    path: '/settings/spaces/$spaceId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsCarriersCarrierIdIndexRoute =
  AuthenticatedSettingsCarriersCarrierIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsCarriersCarrierIdRoute,
  } as any)
const AuthenticatedSettingsCarriersCarrierIdDriversRoute =
  AuthenticatedSettingsCarriersCarrierIdDriversRouteImport.update({
    id: '/drivers',
    path: '/drivers',
    getParentRoute: () => AuthenticatedSettingsCarriersCarrierIdRoute,
  } as any)
const AuthenticatedSettingsCarriersCarrierIdSitesRoute =
  AuthenticatedSettingsCarriersCarrierIdSitesRouteImport.update({
    id: '/sites',
    path: '/sites',
    getParentRoute: () => AuthenticatedSettingsCarriersCarrierIdRoute,
  } as any)
const AuthenticatedSettingsCarriersCarrierIdVehiclesRoute =
  AuthenticatedSettingsCarriersCarrierIdVehiclesRouteImport.update({
    id: '/vehicles',
    path: '/vehicles',
    getParentRoute: () => AuthenticatedSettingsCarriersCarrierIdRoute,
  } as any)
const AuthenticatedSettingsSitesSiteIdIndexRoute =
  AuthenticatedSettingsSitesSiteIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsSitesSiteIdRoute,
  } as any)
const AuthenticatedSettingsSitesSiteIdCarriersRoute =
  AuthenticatedSettingsSitesSiteIdCarriersRouteImport.update({
    id: '/carriers',
    path: '/carriers',
    getParentRoute: () => AuthenticatedSettingsSitesSiteIdRoute,
  } as any)
const AuthenticatedSettingsSitesSiteIdDefaultsRoute =
  AuthenticatedSettingsSitesSiteIdDefaultsRouteImport.update({
    id: '/defaults',
    path: '/defaults',
    getParentRoute: () => AuthenticatedSettingsSitesSiteIdRoute,
  } as any)
const AuthenticatedSettingsSitesSiteIdDriversRoute =
  AuthenticatedSettingsSitesSiteIdDriversRouteImport.update({
    id: '/drivers',
    path: '/drivers',
    getParentRoute: () => AuthenticatedSettingsSitesSiteIdRoute,
  } as any)
const AuthenticatedSettingsSitesSiteIdUsersRoute =
  AuthenticatedSettingsSitesSiteIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedSettingsSitesSiteIdRoute,
  } as any)
const AuthenticatedSettingsSitesSiteIdVehiclesRoute =
  AuthenticatedSettingsSitesSiteIdVehiclesRouteImport.update({
    id: '/vehicles',
    path: '/vehicles',
    getParentRoute: () => AuthenticatedSettingsSitesSiteIdRoute,
  } as any)
const AuthenticatedSettingsSpacesSpaceIdIndexRoute =
  AuthenticatedSettingsSpacesSpaceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsSpacesSpaceIdRoute,
  } as any)
const AuthenticatedSettingsSpacesSpaceIdCarriersRoute =
  AuthenticatedSettingsSpacesSpaceIdCarriersRouteImport.update({
    id: '/carriers',
    path: '/carriers',
    getParentRoute: () => AuthenticatedSettingsSpacesSpaceIdRoute,
  } as any)
const AuthenticatedSettingsSpacesSpaceIdDriversRoute =
  AuthenticatedSettingsSpacesSpaceIdDriversRouteImport.update({
    id: '/drivers',
    path: '/drivers',
    getParentRoute: () => AuthenticatedSettingsSpacesSpaceIdRoute,
  } as any)
const AuthenticatedSettingsSpacesSpaceIdSitesRoute =
  AuthenticatedSettingsSpacesSpaceIdSitesRouteImport.update({
    id: '/sites',
    path: '/sites',
    getParentRoute: () => AuthenticatedSettingsSpacesSpaceIdRoute,
  } as any)
const AuthenticatedSettingsSpacesSpaceIdUsersRoute =
  AuthenticatedSettingsSpacesSpaceIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedSettingsSpacesSpaceIdRoute,
  } as any)
const AuthenticatedSettingsSpacesSpaceIdVehiclesRoute =
  AuthenticatedSettingsSpacesSpaceIdVehiclesRouteImport.update({
    id: '/vehicles',
    path: '/vehicles',
    getParentRoute: () => AuthenticatedSettingsSpacesSpaceIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/activate': typeof ActivateRoute
  '/onboarding': typeof OnboardingRoute
  '/customers': typeof AuthenticatedCustomersRoute
  '/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/signup': typeof PublicSignupRoute
  '/imports/history': typeof AuthenticatedImportsHistoryRoute
  '/settings/billing': typeof AuthenticatedSettingsBillingRoute
  '/settings/defaults': typeof AuthenticatedSettingsDefaultsRoute
  '/settings/handling-units': typeof AuthenticatedSettingsHandlingUnitsRoute
  '/settings/national-carriers': typeof AuthenticatedSettingsNationalCarriersRoute
  '/settings/order-types': typeof AuthenticatedSettingsOrderTypesRoute
  '/settings/organization': typeof AuthenticatedSettingsOrganizationRoute
  '/settings/service-keys': typeof AuthenticatedSettingsServiceKeysRoute
  '/settings/shippers': typeof AuthenticatedSettingsShippersRoute
  '/settings/spaces': typeof AuthenticatedSettingsSpacesRouteWithChildren
  '/settings/users': typeof AuthenticatedSettingsUsersRoute
  '/settings/vehicle-templates': typeof AuthenticatedSettingsVehicleTemplatesRoute
  '/imports/': typeof AuthenticatedImportsIndexRoute
  '/orders/': typeof AuthenticatedOrdersIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/imports/history/$importId': typeof AuthenticatedImportsHistoryImportIdRoute
  '/settings/carriers/$carrierId': typeof AuthenticatedSettingsCarriersCarrierIdRouteWithChildren
  '/settings/sites/$siteId': typeof AuthenticatedSettingsSitesSiteIdRouteWithChildren
  '/settings/spaces/$spaceId': typeof AuthenticatedSettingsSpacesSpaceIdRouteWithChildren
  '/settings/spaces/': typeof AuthenticatedSettingsSpacesIndexRoute
  '/settings/carriers/$carrierId/drivers': typeof AuthenticatedSettingsCarriersCarrierIdDriversRoute
  '/settings/carriers/$carrierId/sites': typeof AuthenticatedSettingsCarriersCarrierIdSitesRoute
  '/settings/carriers/$carrierId/vehicles': typeof AuthenticatedSettingsCarriersCarrierIdVehiclesRoute
  '/settings/sites/$siteId/carriers': typeof AuthenticatedSettingsSitesSiteIdCarriersRoute
  '/settings/sites/$siteId/defaults': typeof AuthenticatedSettingsSitesSiteIdDefaultsRoute
  '/settings/sites/$siteId/drivers': typeof AuthenticatedSettingsSitesSiteIdDriversRoute
  '/settings/sites/$siteId/users': typeof AuthenticatedSettingsSitesSiteIdUsersRoute
  '/settings/sites/$siteId/vehicles': typeof AuthenticatedSettingsSitesSiteIdVehiclesRoute
  '/settings/spaces/$spaceId/carriers': typeof AuthenticatedSettingsSpacesSpaceIdCarriersRoute
  '/settings/spaces/$spaceId/drivers': typeof AuthenticatedSettingsSpacesSpaceIdDriversRoute
  '/settings/spaces/$spaceId/sites': typeof AuthenticatedSettingsSpacesSpaceIdSitesRoute
  '/settings/spaces/$spaceId/users': typeof AuthenticatedSettingsSpacesSpaceIdUsersRoute
  '/settings/spaces/$spaceId/vehicles': typeof AuthenticatedSettingsSpacesSpaceIdVehiclesRoute
  '/settings/carriers/$carrierId/': typeof AuthenticatedSettingsCarriersCarrierIdIndexRoute
  '/settings/sites/$siteId/': typeof AuthenticatedSettingsSitesSiteIdIndexRoute
  '/settings/spaces/$spaceId/': typeof AuthenticatedSettingsSpacesSpaceIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedIndexRoute
  '/activate': typeof ActivateRoute
  '/onboarding': typeof OnboardingRoute
  '/customers': typeof AuthenticatedCustomersRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/signup': typeof PublicSignupRoute
  '/imports/history': typeof AuthenticatedImportsHistoryRoute
  '/settings/billing': typeof AuthenticatedSettingsBillingRoute
  '/settings/defaults': typeof AuthenticatedSettingsDefaultsRoute
  '/settings/handling-units': typeof AuthenticatedSettingsHandlingUnitsRoute
  '/settings/national-carriers': typeof AuthenticatedSettingsNationalCarriersRoute
  '/settings/order-types': typeof AuthenticatedSettingsOrderTypesRoute
  '/settings/organization': typeof AuthenticatedSettingsOrganizationRoute
  '/settings/service-keys': typeof AuthenticatedSettingsServiceKeysRoute
  '/settings/shippers': typeof AuthenticatedSettingsShippersRoute
  '/settings/users': typeof AuthenticatedSettingsUsersRoute
  '/settings/vehicle-templates': typeof AuthenticatedSettingsVehicleTemplatesRoute
  '/imports': typeof AuthenticatedImportsIndexRoute
  '/orders': typeof AuthenticatedOrdersIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/imports/history/$importId': typeof AuthenticatedImportsHistoryImportIdRoute
  '/settings/spaces': typeof AuthenticatedSettingsSpacesIndexRoute
  '/settings/carriers/$carrierId/drivers': typeof AuthenticatedSettingsCarriersCarrierIdDriversRoute
  '/settings/carriers/$carrierId/sites': typeof AuthenticatedSettingsCarriersCarrierIdSitesRoute
  '/settings/carriers/$carrierId/vehicles': typeof AuthenticatedSettingsCarriersCarrierIdVehiclesRoute
  '/settings/sites/$siteId/carriers': typeof AuthenticatedSettingsSitesSiteIdCarriersRoute
  '/settings/sites/$siteId/defaults': typeof AuthenticatedSettingsSitesSiteIdDefaultsRoute
  '/settings/sites/$siteId/drivers': typeof AuthenticatedSettingsSitesSiteIdDriversRoute
  '/settings/sites/$siteId/users': typeof AuthenticatedSettingsSitesSiteIdUsersRoute
  '/settings/sites/$siteId/vehicles': typeof AuthenticatedSettingsSitesSiteIdVehiclesRoute
  '/settings/spaces/$spaceId/carriers': typeof AuthenticatedSettingsSpacesSpaceIdCarriersRoute
  '/settings/spaces/$spaceId/drivers': typeof AuthenticatedSettingsSpacesSpaceIdDriversRoute
  '/settings/spaces/$spaceId/sites': typeof AuthenticatedSettingsSpacesSpaceIdSitesRoute
  '/settings/spaces/$spaceId/users': typeof AuthenticatedSettingsSpacesSpaceIdUsersRoute
  '/settings/spaces/$spaceId/vehicles': typeof AuthenticatedSettingsSpacesSpaceIdVehiclesRoute
  '/settings/carriers/$carrierId': typeof AuthenticatedSettingsCarriersCarrierIdIndexRoute
  '/settings/sites/$siteId': typeof AuthenticatedSettingsSitesSiteIdIndexRoute
  '/settings/spaces/$spaceId': typeof AuthenticatedSettingsSpacesSpaceIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/activate': typeof ActivateRoute
  '/onboarding': typeof OnboardingRoute
  '/_authenticated/customers': typeof AuthenticatedCustomersRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/_public/forgot-password': typeof PublicForgotPasswordRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/reset-password': typeof PublicResetPasswordRoute
  '/_public/signup': typeof PublicSignupRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/imports/history': typeof AuthenticatedImportsHistoryRoute
  '/_authenticated/settings/billing': typeof AuthenticatedSettingsBillingRoute
  '/_authenticated/settings/defaults': typeof AuthenticatedSettingsDefaultsRoute
  '/_authenticated/settings/handling-units': typeof AuthenticatedSettingsHandlingUnitsRoute
  '/_authenticated/settings/national-carriers': typeof AuthenticatedSettingsNationalCarriersRoute
  '/_authenticated/settings/order-types': typeof AuthenticatedSettingsOrderTypesRoute
  '/_authenticated/settings/organization': typeof AuthenticatedSettingsOrganizationRoute
  '/_authenticated/settings/service-keys': typeof AuthenticatedSettingsServiceKeysRoute
  '/_authenticated/settings/shippers': typeof AuthenticatedSettingsShippersRoute
  '/_authenticated/settings/spaces': typeof AuthenticatedSettingsSpacesRouteWithChildren
  '/_authenticated/settings/users': typeof AuthenticatedSettingsUsersRoute
  '/_authenticated/settings/vehicle-templates': typeof AuthenticatedSettingsVehicleTemplatesRoute
  '/_authenticated/imports/': typeof AuthenticatedImportsIndexRoute
  '/_authenticated/orders/': typeof AuthenticatedOrdersIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/imports/history_/$importId': typeof AuthenticatedImportsHistoryImportIdRoute
  '/_authenticated/settings_/carriers/$carrierId': typeof AuthenticatedSettingsCarriersCarrierIdRouteWithChildren
  '/_authenticated/settings_/sites/$siteId': typeof AuthenticatedSettingsSitesSiteIdRouteWithChildren
  '/_authenticated/settings_/spaces/$spaceId': typeof AuthenticatedSettingsSpacesSpaceIdRouteWithChildren
  '/_authenticated/settings/spaces/': typeof AuthenticatedSettingsSpacesIndexRoute
  '/_authenticated/settings_/carriers/$carrierId/drivers': typeof AuthenticatedSettingsCarriersCarrierIdDriversRoute
  '/_authenticated/settings_/carriers/$carrierId/sites': typeof AuthenticatedSettingsCarriersCarrierIdSitesRoute
  '/_authenticated/settings_/carriers/$carrierId/vehicles': typeof AuthenticatedSettingsCarriersCarrierIdVehiclesRoute
  '/_authenticated/settings_/sites/$siteId/carriers': typeof AuthenticatedSettingsSitesSiteIdCarriersRoute
  '/_authenticated/settings_/sites/$siteId/defaults': typeof AuthenticatedSettingsSitesSiteIdDefaultsRoute
  '/_authenticated/settings_/sites/$siteId/drivers': typeof AuthenticatedSettingsSitesSiteIdDriversRoute
  '/_authenticated/settings_/sites/$siteId/users': typeof AuthenticatedSettingsSitesSiteIdUsersRoute
  '/_authenticated/settings_/sites/$siteId/vehicles': typeof AuthenticatedSettingsSitesSiteIdVehiclesRoute
  '/_authenticated/settings_/spaces/$spaceId/carriers': typeof AuthenticatedSettingsSpacesSpaceIdCarriersRoute
  '/_authenticated/settings_/spaces/$spaceId/drivers': typeof AuthenticatedSettingsSpacesSpaceIdDriversRoute
  '/_authenticated/settings_/spaces/$spaceId/sites': typeof AuthenticatedSettingsSpacesSpaceIdSitesRoute
  '/_authenticated/settings_/spaces/$spaceId/users': typeof AuthenticatedSettingsSpacesSpaceIdUsersRoute
  '/_authenticated/settings_/spaces/$spaceId/vehicles': typeof AuthenticatedSettingsSpacesSpaceIdVehiclesRoute
  '/_authenticated/settings_/carriers/$carrierId/': typeof AuthenticatedSettingsCarriersCarrierIdIndexRoute
  '/_authenticated/settings_/sites/$siteId/': typeof AuthenticatedSettingsSitesSiteIdIndexRoute
  '/_authenticated/settings_/spaces/$spaceId/': typeof AuthenticatedSettingsSpacesSpaceIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activate'
    | '/onboarding'
    | '/customers'
    | '/settings'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/imports/history'
    | '/settings/billing'
    | '/settings/defaults'
    | '/settings/handling-units'
    | '/settings/national-carriers'
    | '/settings/order-types'
    | '/settings/organization'
    | '/settings/service-keys'
    | '/settings/shippers'
    | '/settings/spaces'
    | '/settings/users'
    | '/settings/vehicle-templates'
    | '/imports/'
    | '/orders/'
    | '/settings/'
    | '/imports/history/$importId'
    | '/settings/carriers/$carrierId'
    | '/settings/sites/$siteId'
    | '/settings/spaces/$spaceId'
    | '/settings/spaces/'
    | '/settings/carriers/$carrierId/drivers'
    | '/settings/carriers/$carrierId/sites'
    | '/settings/carriers/$carrierId/vehicles'
    | '/settings/sites/$siteId/carriers'
    | '/settings/sites/$siteId/defaults'
    | '/settings/sites/$siteId/drivers'
    | '/settings/sites/$siteId/users'
    | '/settings/sites/$siteId/vehicles'
    | '/settings/spaces/$spaceId/carriers'
    | '/settings/spaces/$spaceId/drivers'
    | '/settings/spaces/$spaceId/sites'
    | '/settings/spaces/$spaceId/users'
    | '/settings/spaces/$spaceId/vehicles'
    | '/settings/carriers/$carrierId/'
    | '/settings/sites/$siteId/'
    | '/settings/spaces/$spaceId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activate'
    | '/onboarding'
    | '/customers'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/imports/history'
    | '/settings/billing'
    | '/settings/defaults'
    | '/settings/handling-units'
    | '/settings/national-carriers'
    | '/settings/order-types'
    | '/settings/organization'
    | '/settings/service-keys'
    | '/settings/shippers'
    | '/settings/users'
    | '/settings/vehicle-templates'
    | '/imports'
    | '/orders'
    | '/settings'
    | '/imports/history/$importId'
    | '/settings/spaces'
    | '/settings/carriers/$carrierId/drivers'
    | '/settings/carriers/$carrierId/sites'
    | '/settings/carriers/$carrierId/vehicles'
    | '/settings/sites/$siteId/carriers'
    | '/settings/sites/$siteId/defaults'
    | '/settings/sites/$siteId/drivers'
    | '/settings/sites/$siteId/users'
    | '/settings/sites/$siteId/vehicles'
    | '/settings/spaces/$spaceId/carriers'
    | '/settings/spaces/$spaceId/drivers'
    | '/settings/spaces/$spaceId/sites'
    | '/settings/spaces/$spaceId/users'
    | '/settings/spaces/$spaceId/vehicles'
    | '/settings/carriers/$carrierId'
    | '/settings/sites/$siteId'
    | '/settings/spaces/$spaceId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_public'
    | '/activate'
    | '/onboarding'
    | '/_authenticated/customers'
    | '/_authenticated/settings'
    | '/_public/forgot-password'
    | '/_public/login'
    | '/_public/reset-password'
    | '/_public/signup'
    | '/_authenticated/'
    | '/_authenticated/imports/history'
    | '/_authenticated/settings/billing'
    | '/_authenticated/settings/defaults'
    | '/_authenticated/settings/handling-units'
    | '/_authenticated/settings/national-carriers'
    | '/_authenticated/settings/order-types'
    | '/_authenticated/settings/organization'
    | '/_authenticated/settings/service-keys'
    | '/_authenticated/settings/shippers'
    | '/_authenticated/settings/spaces'
    | '/_authenticated/settings/users'
    | '/_authenticated/settings/vehicle-templates'
    | '/_authenticated/imports/'
    | '/_authenticated/orders/'
    | '/_authenticated/settings/'
    | '/_authenticated/imports/history_/$importId'
    | '/_authenticated/settings_/carriers/$carrierId'
    | '/_authenticated/settings_/sites/$siteId'
    | '/_authenticated/settings_/spaces/$spaceId'
    | '/_authenticated/settings/spaces/'
    | '/_authenticated/settings_/carriers/$carrierId/drivers'
    | '/_authenticated/settings_/carriers/$carrierId/sites'
    | '/_authenticated/settings_/carriers/$carrierId/vehicles'
    | '/_authenticated/settings_/sites/$siteId/carriers'
    | '/_authenticated/settings_/sites/$siteId/defaults'
    | '/_authenticated/settings_/sites/$siteId/drivers'
    | '/_authenticated/settings_/sites/$siteId/users'
    | '/_authenticated/settings_/sites/$siteId/vehicles'
    | '/_authenticated/settings_/spaces/$spaceId/carriers'
    | '/_authenticated/settings_/spaces/$spaceId/drivers'
    | '/_authenticated/settings_/spaces/$spaceId/sites'
    | '/_authenticated/settings_/spaces/$spaceId/users'
    | '/_authenticated/settings_/spaces/$spaceId/vehicles'
    | '/_authenticated/settings_/carriers/$carrierId/'
    | '/_authenticated/settings_/sites/$siteId/'
    | '/_authenticated/settings_/spaces/$spaceId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  ActivateRoute: typeof ActivateRoute
  OnboardingRoute: typeof OnboardingRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activate': {
      id: '/activate'
      path: '/activate'
      fullPath: '/activate'
      preLoaderRoute: typeof ActivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customers': {
      id: '/_authenticated/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AuthenticatedCustomersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_public/forgot-password': {
      id: '/_public/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof PublicForgotPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/reset-password': {
      id: '/_public/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof PublicResetPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/signup': {
      id: '/_public/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof PublicSignupRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authenticated/imports/': {
      id: '/_authenticated/imports/'
      path: '/imports'
      fullPath: '/imports/'
      preLoaderRoute: typeof AuthenticatedImportsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/imports/history': {
      id: '/_authenticated/imports/history'
      path: '/imports/history'
      fullPath: '/imports/history'
      preLoaderRoute: typeof AuthenticatedImportsHistoryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders/': {
      id: '/_authenticated/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof AuthenticatedOrdersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/billing': {
      id: '/_authenticated/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AuthenticatedSettingsBillingRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/defaults': {
      id: '/_authenticated/settings/defaults'
      path: '/defaults'
      fullPath: '/settings/defaults'
      preLoaderRoute: typeof AuthenticatedSettingsDefaultsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/handling-units': {
      id: '/_authenticated/settings/handling-units'
      path: '/handling-units'
      fullPath: '/settings/handling-units'
      preLoaderRoute: typeof AuthenticatedSettingsHandlingUnitsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/national-carriers': {
      id: '/_authenticated/settings/national-carriers'
      path: '/national-carriers'
      fullPath: '/settings/national-carriers'
      preLoaderRoute: typeof AuthenticatedSettingsNationalCarriersRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/order-types': {
      id: '/_authenticated/settings/order-types'
      path: '/order-types'
      fullPath: '/settings/order-types'
      preLoaderRoute: typeof AuthenticatedSettingsOrderTypesRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/organization': {
      id: '/_authenticated/settings/organization'
      path: '/organization'
      fullPath: '/settings/organization'
      preLoaderRoute: typeof AuthenticatedSettingsOrganizationRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/service-keys': {
      id: '/_authenticated/settings/service-keys'
      path: '/service-keys'
      fullPath: '/settings/service-keys'
      preLoaderRoute: typeof AuthenticatedSettingsServiceKeysRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/shippers': {
      id: '/_authenticated/settings/shippers'
      path: '/shippers'
      fullPath: '/settings/shippers'
      preLoaderRoute: typeof AuthenticatedSettingsShippersRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/spaces': {
      id: '/_authenticated/settings/spaces'
      path: '/spaces'
      fullPath: '/settings/spaces'
      preLoaderRoute: typeof AuthenticatedSettingsSpacesRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/users': {
      id: '/_authenticated/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AuthenticatedSettingsUsersRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/vehicle-templates': {
      id: '/_authenticated/settings/vehicle-templates'
      path: '/vehicle-templates'
      fullPath: '/settings/vehicle-templates'
      preLoaderRoute: typeof AuthenticatedSettingsVehicleTemplatesRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/imports/history_/$importId': {
      id: '/_authenticated/imports/history_/$importId'
      path: '/imports/history/$importId'
      fullPath: '/imports/history/$importId'
      preLoaderRoute: typeof AuthenticatedImportsHistoryImportIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/spaces/': {
      id: '/_authenticated/settings/spaces/'
      path: '/'
      fullPath: '/settings/spaces/'
      preLoaderRoute: typeof AuthenticatedSettingsSpacesIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsSpacesRoute
    }
    '/_authenticated/settings_/carriers/$carrierId': {
      id: '/_authenticated/settings_/carriers/$carrierId'
      path: '/settings/carriers/$carrierId'
      fullPath: '/settings/carriers/$carrierId'
      preLoaderRoute: typeof AuthenticatedSettingsCarriersCarrierIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings_/sites/$siteId': {
      id: '/_authenticated/settings_/sites/$siteId'
      path: '/settings/sites/$siteId'
      fullPath: '/settings/sites/$siteId'
      preLoaderRoute: typeof AuthenticatedSettingsSitesSiteIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings_/spaces/$spaceId': {
      id: '/_authenticated/settings_/spaces/$spaceId'
      path: '/settings/spaces/$spaceId'
      fullPath: '/settings/spaces/$spaceId'
      preLoaderRoute: typeof AuthenticatedSettingsSpacesSpaceIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings_/carriers/$carrierId/': {
      id: '/_authenticated/settings_/carriers/$carrierId/'
      path: '/'
      fullPath: '/settings/carriers/$carrierId/'
      preLoaderRoute: typeof AuthenticatedSettingsCarriersCarrierIdIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsCarriersCarrierIdRoute
    }
    '/_authenticated/settings_/carriers/$carrierId/drivers': {
      id: '/_authenticated/settings_/carriers/$carrierId/drivers'
      path: '/drivers'
      fullPath: '/settings/carriers/$carrierId/drivers'
      preLoaderRoute: typeof AuthenticatedSettingsCarriersCarrierIdDriversRouteImport
      parentRoute: typeof AuthenticatedSettingsCarriersCarrierIdRoute
    }
    '/_authenticated/settings_/carriers/$carrierId/sites': {
      id: '/_authenticated/settings_/carriers/$carrierId/sites'
      path: '/sites'
      fullPath: '/settings/carriers/$carrierId/sites'
      preLoaderRoute: typeof AuthenticatedSettingsCarriersCarrierIdSitesRouteImport
      parentRoute: typeof AuthenticatedSettingsCarriersCarrierIdRoute
    }
    '/_authenticated/settings_/carriers/$carrierId/vehicles': {
      id: '/_authenticated/settings_/carriers/$carrierId/vehicles'
      path: '/vehicles'
      fullPath: '/settings/carriers/$carrierId/vehicles'
      preLoaderRoute: typeof AuthenticatedSettingsCarriersCarrierIdVehiclesRouteImport
      parentRoute: typeof AuthenticatedSettingsCarriersCarrierIdRoute
    }
    '/_authenticated/settings_/sites/$siteId/': {
      id: '/_authenticated/settings_/sites/$siteId/'
      path: '/'
      fullPath: '/settings/sites/$siteId/'
      preLoaderRoute: typeof AuthenticatedSettingsSitesSiteIdIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsSitesSiteIdRoute
    }
    '/_authenticated/settings_/sites/$siteId/carriers': {
      id: '/_authenticated/settings_/sites/$siteId/carriers'
      path: '/carriers'
      fullPath: '/settings/sites/$siteId/carriers'
      preLoaderRoute: typeof AuthenticatedSettingsSitesSiteIdCarriersRouteImport
      parentRoute: typeof AuthenticatedSettingsSitesSiteIdRoute
    }
    '/_authenticated/settings_/sites/$siteId/defaults': {
      id: '/_authenticated/settings_/sites/$siteId/defaults'
      path: '/defaults'
      fullPath: '/settings/sites/$siteId/defaults'
      preLoaderRoute: typeof AuthenticatedSettingsSitesSiteIdDefaultsRouteImport
      parentRoute: typeof AuthenticatedSettingsSitesSiteIdRoute
    }
    '/_authenticated/settings_/sites/$siteId/drivers': {
      id: '/_authenticated/settings_/sites/$siteId/drivers'
      path: '/drivers'
      fullPath: '/settings/sites/$siteId/drivers'
      preLoaderRoute: typeof AuthenticatedSettingsSitesSiteIdDriversRouteImport
      parentRoute: typeof AuthenticatedSettingsSitesSiteIdRoute
    }
    '/_authenticated/settings_/sites/$siteId/users': {
      id: '/_authenticated/settings_/sites/$siteId/users'
      path: '/users'
      fullPath: '/settings/sites/$siteId/users'
      preLoaderRoute: typeof AuthenticatedSettingsSitesSiteIdUsersRouteImport
      parentRoute: typeof AuthenticatedSettingsSitesSiteIdRoute
    }
    '/_authenticated/settings_/sites/$siteId/vehicles': {
      id: '/_authenticated/settings_/sites/$siteId/vehicles'
      path: '/vehicles'
      fullPath: '/settings/sites/$siteId/vehicles'
      preLoaderRoute: typeof AuthenticatedSettingsSitesSiteIdVehiclesRouteImport
      parentRoute: typeof AuthenticatedSettingsSitesSiteIdRoute
    }
    '/_authenticated/settings_/spaces/$spaceId/': {
      id: '/_authenticated/settings_/spaces/$spaceId/'
      path: '/'
      fullPath: '/settings/spaces/$spaceId/'
      preLoaderRoute: typeof AuthenticatedSettingsSpacesSpaceIdIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsSpacesSpaceIdRoute
    }
    '/_authenticated/settings_/spaces/$spaceId/carriers': {
      id: '/_authenticated/settings_/spaces/$spaceId/carriers'
      path: '/carriers'
      fullPath: '/settings/spaces/$spaceId/carriers'
      preLoaderRoute: typeof AuthenticatedSettingsSpacesSpaceIdCarriersRouteImport
      parentRoute: typeof AuthenticatedSettingsSpacesSpaceIdRoute
    }
    '/_authenticated/settings_/spaces/$spaceId/drivers': {
      id: '/_authenticated/settings_/spaces/$spaceId/drivers'
      path: '/drivers'
      fullPath: '/settings/spaces/$spaceId/drivers'
      preLoaderRoute: typeof AuthenticatedSettingsSpacesSpaceIdDriversRouteImport
      parentRoute: typeof AuthenticatedSettingsSpacesSpaceIdRoute
    }
    '/_authenticated/settings_/spaces/$spaceId/sites': {
      id: '/_authenticated/settings_/spaces/$spaceId/sites'
      path: '/sites'
      fullPath: '/settings/spaces/$spaceId/sites'
      preLoaderRoute: typeof AuthenticatedSettingsSpacesSpaceIdSitesRouteImport
      parentRoute: typeof AuthenticatedSettingsSpacesSpaceIdRoute
    }
    '/_authenticated/settings_/spaces/$spaceId/users': {
      id: '/_authenticated/settings_/spaces/$spaceId/users'
      path: '/users'
      fullPath: '/settings/spaces/$spaceId/users'
      preLoaderRoute: typeof AuthenticatedSettingsSpacesSpaceIdUsersRouteImport
      parentRoute: typeof AuthenticatedSettingsSpacesSpaceIdRoute
    }
    '/_authenticated/settings_/spaces/$spaceId/vehicles': {
      id: '/_authenticated/settings_/spaces/$spaceId/vehicles'
      path: '/vehicles'
      fullPath: '/settings/spaces/$spaceId/vehicles'
      preLoaderRoute: typeof AuthenticatedSettingsSpacesSpaceIdVehiclesRouteImport
      parentRoute: typeof AuthenticatedSettingsSpacesSpaceIdRoute
    }
  }
}

interface AuthenticatedSettingsSpacesRouteChildren {
  AuthenticatedSettingsSpacesIndexRoute: typeof AuthenticatedSettingsSpacesIndexRoute
}

const AuthenticatedSettingsSpacesRouteChildren: AuthenticatedSettingsSpacesRouteChildren =
  {
    AuthenticatedSettingsSpacesIndexRoute:
      AuthenticatedSettingsSpacesIndexRoute,
  }

const AuthenticatedSettingsSpacesRouteWithChildren =
  AuthenticatedSettingsSpacesRoute._addFileChildren(
    AuthenticatedSettingsSpacesRouteChildren,
  )

interface AuthenticatedSettingsRouteChildren {
  AuthenticatedSettingsBillingRoute: typeof AuthenticatedSettingsBillingRoute
  AuthenticatedSettingsDefaultsRoute: typeof AuthenticatedSettingsDefaultsRoute
  AuthenticatedSettingsHandlingUnitsRoute: typeof AuthenticatedSettingsHandlingUnitsRoute
  AuthenticatedSettingsNationalCarriersRoute: typeof AuthenticatedSettingsNationalCarriersRoute
  AuthenticatedSettingsOrderTypesRoute: typeof AuthenticatedSettingsOrderTypesRoute
  AuthenticatedSettingsOrganizationRoute: typeof AuthenticatedSettingsOrganizationRoute
  AuthenticatedSettingsServiceKeysRoute: typeof AuthenticatedSettingsServiceKeysRoute
  AuthenticatedSettingsShippersRoute: typeof AuthenticatedSettingsShippersRoute
  AuthenticatedSettingsSpacesRoute: typeof AuthenticatedSettingsSpacesRouteWithChildren
  AuthenticatedSettingsUsersRoute: typeof AuthenticatedSettingsUsersRoute
  AuthenticatedSettingsVehicleTemplatesRoute: typeof AuthenticatedSettingsVehicleTemplatesRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteChildren: AuthenticatedSettingsRouteChildren = {
  AuthenticatedSettingsBillingRoute: AuthenticatedSettingsBillingRoute,
  AuthenticatedSettingsDefaultsRoute: AuthenticatedSettingsDefaultsRoute,
  AuthenticatedSettingsHandlingUnitsRoute:
    AuthenticatedSettingsHandlingUnitsRoute,
  AuthenticatedSettingsNationalCarriersRoute:
    AuthenticatedSettingsNationalCarriersRoute,
  AuthenticatedSettingsOrderTypesRoute: AuthenticatedSettingsOrderTypesRoute,
  AuthenticatedSettingsOrganizationRoute:
    AuthenticatedSettingsOrganizationRoute,
  AuthenticatedSettingsServiceKeysRoute: AuthenticatedSettingsServiceKeysRoute,
  AuthenticatedSettingsShippersRoute: AuthenticatedSettingsShippersRoute,
  AuthenticatedSettingsSpacesRoute:
    AuthenticatedSettingsSpacesRouteWithChildren,
  AuthenticatedSettingsUsersRoute: AuthenticatedSettingsUsersRoute,
  AuthenticatedSettingsVehicleTemplatesRoute:
    AuthenticatedSettingsVehicleTemplatesRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
}

const AuthenticatedSettingsRouteWithChildren =
  AuthenticatedSettingsRoute._addFileChildren(
    AuthenticatedSettingsRouteChildren,
  )

interface AuthenticatedSettingsCarriersCarrierIdRouteChildren {
  AuthenticatedSettingsCarriersCarrierIdDriversRoute: typeof AuthenticatedSettingsCarriersCarrierIdDriversRoute
  AuthenticatedSettingsCarriersCarrierIdSitesRoute: typeof AuthenticatedSettingsCarriersCarrierIdSitesRoute
  AuthenticatedSettingsCarriersCarrierIdVehiclesRoute: typeof AuthenticatedSettingsCarriersCarrierIdVehiclesRoute
  AuthenticatedSettingsCarriersCarrierIdIndexRoute: typeof AuthenticatedSettingsCarriersCarrierIdIndexRoute
}

const AuthenticatedSettingsCarriersCarrierIdRouteChildren: AuthenticatedSettingsCarriersCarrierIdRouteChildren =
  {
    AuthenticatedSettingsCarriersCarrierIdDriversRoute:
      AuthenticatedSettingsCarriersCarrierIdDriversRoute,
    AuthenticatedSettingsCarriersCarrierIdSitesRoute:
      AuthenticatedSettingsCarriersCarrierIdSitesRoute,
    AuthenticatedSettingsCarriersCarrierIdVehiclesRoute:
      AuthenticatedSettingsCarriersCarrierIdVehiclesRoute,
    AuthenticatedSettingsCarriersCarrierIdIndexRoute:
      AuthenticatedSettingsCarriersCarrierIdIndexRoute,
  }

const AuthenticatedSettingsCarriersCarrierIdRouteWithChildren =
  AuthenticatedSettingsCarriersCarrierIdRoute._addFileChildren(
    AuthenticatedSettingsCarriersCarrierIdRouteChildren,
  )

interface AuthenticatedSettingsSitesSiteIdRouteChildren {
  AuthenticatedSettingsSitesSiteIdCarriersRoute: typeof AuthenticatedSettingsSitesSiteIdCarriersRoute
  AuthenticatedSettingsSitesSiteIdDefaultsRoute: typeof AuthenticatedSettingsSitesSiteIdDefaultsRoute
  AuthenticatedSettingsSitesSiteIdDriversRoute: typeof AuthenticatedSettingsSitesSiteIdDriversRoute
  AuthenticatedSettingsSitesSiteIdUsersRoute: typeof AuthenticatedSettingsSitesSiteIdUsersRoute
  AuthenticatedSettingsSitesSiteIdVehiclesRoute: typeof AuthenticatedSettingsSitesSiteIdVehiclesRoute
  AuthenticatedSettingsSitesSiteIdIndexRoute: typeof AuthenticatedSettingsSitesSiteIdIndexRoute
}

const AuthenticatedSettingsSitesSiteIdRouteChildren: AuthenticatedSettingsSitesSiteIdRouteChildren =
  {
    AuthenticatedSettingsSitesSiteIdCarriersRoute:
      AuthenticatedSettingsSitesSiteIdCarriersRoute,
    AuthenticatedSettingsSitesSiteIdDefaultsRoute:
      AuthenticatedSettingsSitesSiteIdDefaultsRoute,
    AuthenticatedSettingsSitesSiteIdDriversRoute:
      AuthenticatedSettingsSitesSiteIdDriversRoute,
    AuthenticatedSettingsSitesSiteIdUsersRoute:
      AuthenticatedSettingsSitesSiteIdUsersRoute,
    AuthenticatedSettingsSitesSiteIdVehiclesRoute:
      AuthenticatedSettingsSitesSiteIdVehiclesRoute,
    AuthenticatedSettingsSitesSiteIdIndexRoute:
      AuthenticatedSettingsSitesSiteIdIndexRoute,
  }

const AuthenticatedSettingsSitesSiteIdRouteWithChildren =
  AuthenticatedSettingsSitesSiteIdRoute._addFileChildren(
    AuthenticatedSettingsSitesSiteIdRouteChildren,
  )

interface AuthenticatedSettingsSpacesSpaceIdRouteChildren {
  AuthenticatedSettingsSpacesSpaceIdCarriersRoute: typeof AuthenticatedSettingsSpacesSpaceIdCarriersRoute
  AuthenticatedSettingsSpacesSpaceIdDriversRoute: typeof AuthenticatedSettingsSpacesSpaceIdDriversRoute
  AuthenticatedSettingsSpacesSpaceIdSitesRoute: typeof AuthenticatedSettingsSpacesSpaceIdSitesRoute
  AuthenticatedSettingsSpacesSpaceIdUsersRoute: typeof AuthenticatedSettingsSpacesSpaceIdUsersRoute
  AuthenticatedSettingsSpacesSpaceIdVehiclesRoute: typeof AuthenticatedSettingsSpacesSpaceIdVehiclesRoute
  AuthenticatedSettingsSpacesSpaceIdIndexRoute: typeof AuthenticatedSettingsSpacesSpaceIdIndexRoute
}

const AuthenticatedSettingsSpacesSpaceIdRouteChildren: AuthenticatedSettingsSpacesSpaceIdRouteChildren =
  {
    AuthenticatedSettingsSpacesSpaceIdCarriersRoute:
      AuthenticatedSettingsSpacesSpaceIdCarriersRoute,
    AuthenticatedSettingsSpacesSpaceIdDriversRoute:
      AuthenticatedSettingsSpacesSpaceIdDriversRoute,
    AuthenticatedSettingsSpacesSpaceIdSitesRoute:
      AuthenticatedSettingsSpacesSpaceIdSitesRoute,
    AuthenticatedSettingsSpacesSpaceIdUsersRoute:
      AuthenticatedSettingsSpacesSpaceIdUsersRoute,
    AuthenticatedSettingsSpacesSpaceIdVehiclesRoute:
      AuthenticatedSettingsSpacesSpaceIdVehiclesRoute,
    AuthenticatedSettingsSpacesSpaceIdIndexRoute:
      AuthenticatedSettingsSpacesSpaceIdIndexRoute,
  }

const AuthenticatedSettingsSpacesSpaceIdRouteWithChildren =
  AuthenticatedSettingsSpacesSpaceIdRoute._addFileChildren(
    AuthenticatedSettingsSpacesSpaceIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedCustomersRoute: typeof AuthenticatedCustomersRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedImportsHistoryRoute: typeof AuthenticatedImportsHistoryRoute
  AuthenticatedImportsIndexRoute: typeof AuthenticatedImportsIndexRoute
  AuthenticatedOrdersIndexRoute: typeof AuthenticatedOrdersIndexRoute
  AuthenticatedImportsHistoryImportIdRoute: typeof AuthenticatedImportsHistoryImportIdRoute
  AuthenticatedSettingsCarriersCarrierIdRoute: typeof AuthenticatedSettingsCarriersCarrierIdRouteWithChildren
  AuthenticatedSettingsSitesSiteIdRoute: typeof AuthenticatedSettingsSitesSiteIdRouteWithChildren
  AuthenticatedSettingsSpacesSpaceIdRoute: typeof AuthenticatedSettingsSpacesSpaceIdRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedCustomersRoute: AuthenticatedCustomersRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedImportsHistoryRoute: AuthenticatedImportsHistoryRoute,
  AuthenticatedImportsIndexRoute: AuthenticatedImportsIndexRoute,
  AuthenticatedOrdersIndexRoute: AuthenticatedOrdersIndexRoute,
  AuthenticatedImportsHistoryImportIdRoute:
    AuthenticatedImportsHistoryImportIdRoute,
  AuthenticatedSettingsCarriersCarrierIdRoute:
    AuthenticatedSettingsCarriersCarrierIdRouteWithChildren,
  AuthenticatedSettingsSitesSiteIdRoute:
    AuthenticatedSettingsSitesSiteIdRouteWithChildren,
  AuthenticatedSettingsSpacesSpaceIdRoute:
    AuthenticatedSettingsSpacesSpaceIdRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface PublicRouteChildren {
  PublicForgotPasswordRoute: typeof PublicForgotPasswordRoute
  PublicLoginRoute: typeof PublicLoginRoute
  PublicResetPasswordRoute: typeof PublicResetPasswordRoute
  PublicSignupRoute: typeof PublicSignupRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicForgotPasswordRoute: PublicForgotPasswordRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicResetPasswordRoute: PublicResetPasswordRoute,
  PublicSignupRoute: PublicSignupRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  ActivateRoute: ActivateRoute,
  OnboardingRoute: OnboardingRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
